import React, { PureComponent } from "react";

import BootstrapTable from "react-bootstrap-table-next";
import ToolkitProvider from "react-bootstrap-table2-toolkit/dist/react-bootstrap-table2-toolkit";

import { MetricTable, selectFormat, Error } from "./../Utils/Utils.js";

const metric = (cell, row, enumObject, params) => {
  const props = { ...cell, ...params };
  return <MetricTable {...props} />;
};

class CampaignPacingHashtagsSummary extends PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      hiddenRows: [],
      expandedRows: false,
      currentRowID: null,
    };
  }

  componentDidMount() {
    this.props.childRef(this);
    this.setState({
      hiddenRows: this.props.data.rows
        .filter((d) => d.title === "")
        .map((row) => row.id),
    });
  }

  renderTable = (data) => {
    const { cells, title, url } = this.props;

    data.forEach((d, i) => (d.id = i));

    const showRows = (row) => {
      // Show specific rows
      let indexesToShow = [];

      for (let i = row.id + 1; i <= data.length - 1; i++) {
        if (data[i].title === "") {
          indexesToShow.push(i);
        } else {
          break;
        }
      }

      this.setState({
        hiddenRows: data
          .filter((d) => d.title === "")
          .map((row) => row.id)
          .filter((x) => !indexesToShow.includes(x)),
        expandedRows: true,
        currentRowID: row.id,
      });
    };

    const hideRows = (row) =>
      this.setState({
        hiddenRows: this.props.data.rows
          .filter((d) => d.title === "")
          .map((row) => row.id),
        expandedRows: false,
        currentRowID: row.id,
      });

    const toggleRows = (row) => {
      this.setState({
        currentRowID: row.id,
      });

      if (
        row.id === this.state.currentRowID ||
        this.state.currentRowID === null
      ) {
        if (this.state.expandedRows) {
          hideRows(row);
        } else {
          showRows(row);
        }
      } else {
        if (this.state.expandedRows) {
          hideRows(row);
          showRows(row);
        } else {
          showRows(row);
        }
      }
    };

    const columns = [
      {
        dataField: "title",
        text: "Hashtag",
        style: {
          width: "100px",
          minWidth: "100px",
          textAlign: "left",
        },
        headerAlign: "left",
        formatExtraData: {
          name: url.split("/")[2],
        },
        csvFormatter: (cell, row) => row && (row.title || row.tweet_text || ""),
        formatter: (cellContent, row) => {
          if (row.platform === "Aggregate") {
            return (
              <>
                <button
                  onClick={() => toggleRows(row)}
                  className="toggleRowButton"
                >
                  <span>{row.title} ↓</span>
                </button>{" "}
              </>
            );
          }
        },
      },
      {
        dataField: "platform",
        text: "Platform",
        style: { width: "80px", minWidth: "80px", verticalAlign: "top" },
        csvFormatter: (cell, row) => row && row.platform,
      },
      {
        dataField: "handle",
        text: "Handle",
        style: { width: "100px", minWidth: "100px", verticalAlign: "top" },
        csvFormatter: (cell, row) => row && row.handle,
      },
      {
        dataField: "reach",
        text: "Reach",
        style: { width: "90px", minWidth: "90px", verticalAlign: "top" },
        formatter: metric,
        csvFormatter: (cell) =>
          selectFormat("csv_number", cell && cell.value, "0,0"),
      },
      {
        dataField: "impressions",
        text: "Impressions",
        style: { width: "90px", minWidth: "90px", verticalAlign: "top" },
        formatter: metric,
        csvFormatter: (cell) =>
          selectFormat("csv_number", cell && cell.value, "0,0"),
      },
      {
        dataField: "organic_impressions",
        text: "Organic Impressions",
        style: { width: "90px", minWidth: "90px", verticalAlign: "top" },
        formatter: metric,
        csvFormatter: (cell) =>
          selectFormat("csv_number", cell && cell.value, "0,0"),
      },
      {
        dataField: "views",
        text: "Video Views",
        style: { width: "90px", minWidth: "90px", verticalAlign: "top" },
        formatter: metric,
        csvFormatter: (cell) =>
          selectFormat("csv_number", cell && cell.value, "0,0"),
      },
      {
        dataField: "organic_views",
        text: "Organic Views",
        style: { width: "90px", minWidth: "90px", verticalAlign: "top" },
        formatter: metric,
        csvFormatter: (cell) =>
          selectFormat("csv_number", cell && cell.value, "0,0"),
      },
      {
        dataField: "engagement_rate",
        text: "Engagement Rate",
        style: { width: "120px", minWidth: "120px", verticalAlign: "top" },
        formatter: metric,
        formatExtraData: { type: "percentage" },
        csvFormatter: (cell) =>
          selectFormat("csv_number", cell && cell.value, "0.000%"),
      },
      {
        dataField: "view_rate",
        text: "View Rate",
        style: { width: "90px", minWidth: "90px", verticalAlign: "top" },
        formatter: metric,
        formatExtraData: { type: "percentage" },
        csvFormatter: (cell) =>
          selectFormat("csv_number", cell && cell.value, "0.000%"),
      },
    ];

    let selected_columns = columns;
    if (cells && cells.length) {
      selected_columns = [];
      cells.forEach((cell, i) =>
        selected_columns.push(columns.find((o) => o.dataField === cell))
      );
    }
    const filename = title.split(" ").join("_") || "spreadsheet";

    const rowStyle = (row) => {
      const style = {};

      if (row.platform === "Aggregate") {
        style.backgroundColor = "#eee";
      }

      return style;
    };

    return (
      <ToolkitProvider
        keyField="id"
        data={data}
        columns={selected_columns}
        striped={false}
        hover={false}
        bordered={false}
        exportCSV={{
          fileName: filename + ".csv",
          exportAll: false,
          onlyExportFiltered: true,
        }}
      >
        {(props) => (
          <BootstrapTable
            {...props.baseProps}
            {...props.csvProps}
            rowStyle={rowStyle}
            hiddenRows={this.state.hiddenRows}
            ref={(el) => (this.childRef = el)}
          />
        )}
      </ToolkitProvider>
    );
  };

  builtInExportCSV = () => this.childRef;

  render() {
    const data = this.props.data.rows;

    if (data.hasData === false) {
      return <Error minHeight={360} />;
    }

    return this.renderTable(data);
  }
}

export default CampaignPacingHashtagsSummary;
